var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delivery-form',{attrs:{"enable-incomplete-registration":true,"enable-delivery-waiting-list":true}})}
var staticRenderFns = []

export { render, staticRenderFns }